import { jsx as _jsx } from "react/jsx-runtime";
import { freddyTheme, Link, Typography } from '@coolblue-development/freddy';
import getAnchorBarItemLinkStyles from './AnchorBarItem.styles.js';
const AnchorBarItem = ({ item, onClick, isActive = false }) => {
    const { href, title, label } = item;
    return (_jsx(Link, { ml: 0, display: "block", p: 300, href: href, title: title, onClick: onClick, sx: getAnchorBarItemLinkStyles({ isActive }), children: _jsx(Typography, { component: "span", fontFamily: "Open Sans", fontWeight: isActive
                ? freddyTheme.typography.fontWeight.openSans.bold
                : freddyTheme.typography.fontWeight.openSans.normal, children: label }) }));
};
export default AnchorBarItem;
//# sourceMappingURL=AnchorBarItem.js.map